<template lang="pug">
.video-thumbnail-detail
  f7-link(
    class="detail-thumbnail",
    @click="$emit('click', videoUrl)")

    .thumbnail(:style="[{'background-image': 'url('+src+')'}]")

    .container
      icon.icon-play(name="play" v-if="ready")
      f7-preloader(color="white" :size="28" v-else)

    label {{ videoTimeFormat(duration) }}
</template>

<style lang="scss" scoped>
.detail-thumbnail {
  position: relative;
  width: 100%;
  padding-top: 100%;

  label {
    position: absolute;
    bottom: 10px;
    right: 10px;
    height: 20px;
    width: 38px;
    border: 0.5px solid #cccccc;
    border-radius: 2px;
    background-color: rgba(34, 34, 34, 0.6);
    text-align: center;
    @extend %footnote-text;
  }

  .thumbnail {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    display: inline-block;
    background-position: center center;
    background-repeat: no-repeat;
  }

  .container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
}
</style>

<script>
import Formatter from '@/components/mixins/Formatter'
import VideoMetaDataGenerator from '@/services/VideoMetaDataGenerator'
export default {
  props: {
    src: { type: String, default: '' },
    videoUrl: { type: String, default: '' },
    ready: { type: Boolean, default: true },
  },
  mixins: [Formatter],
  asyncComputed: {
    duration: {
      async get() {
        if (!this.videoUrl) return ''
        const generator = new VideoMetaDataGenerator(this.videoUrl)
        const metaData = await generator.generate()
        return parseInt(metaData.duration)
      },
      default: '',
    },
  },
}
</script>
